import { FilterOptions } from "@/components/PaidNewsletters/PaidNewslettersInterface";
import { PaidNewsletterListState } from "@/store/paidNewsletters/types";
import { useTranslation } from "react-i18next";
import { NewsletterStatusEnum } from '@dev/ee-api/ee-api-models';

export const useStatusPopoverOptions = (paidNewsletters: PaidNewsletterListState): FilterOptions[] => {
    const { t } = useTranslation();
    return [

        {
            label: t('published'),
            value: NewsletterStatusEnum.Published,
            count: paidNewsletters?.publishedCount
        },
        {
            label: t('unpublished'),
            value: NewsletterStatusEnum.Unpublished,
            count: paidNewsletters?.unpublishedCount,
        },
    ]
};